import type { ModuleComponentProps } from '@/lib/module-registry'
import type { DriveModuleData } from '@/types/task'

export function DriveInputComponent({
  value,
  onChange,
  readOnly,
}: ModuleComponentProps<'drive'>) {
  const url = value?.url ?? ''

  if (readOnly) {
    return url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="block max-w-sm truncate text-sm text-primary hover:underline"
      >
        {url}
      </a>
    ) : (
      <span className="text-sm text-muted-foreground">—</span>
    )
  }

  return (
    <input
      type="url"
      value={url}
      onChange={(e) => onChange({ url: e.target.value } as DriveModuleData)}
      placeholder="https://drive.google.com/..."
      className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
    />
  )
}
